import { LaptopIcon } from 'lucide-react'
import React, { useState } from 'react'

export default function Discovery() {
  const [activeTab, setActiveTab] = useState('discovery')
  const discovery = [
    {
      icon: '../assets/icones/search-laptop.png',
      title: 'Descoberta',
      description:
        'Na etapa de descoberta, fazemos a imersão em dados para compreender os desafios a serem superados e as metas a serem atingidas.',
    },
    {
      icon: '../assets/icones/dev-mobile.png',
      title: 'Desenvolvimento de Solução:',
      description:
        'No desenvolvimento, buscamos antecipar problemas e gerar soluções eficientes e eficazes com agilidade.',
    },
    {
      icon: '../assets/icones/chart.png',
      title: 'Avaliação de Soluções:',
      description:
        'Nesta etapa, avaliamos as melhores estratégias e soluções para vencer desafios específicos e elevar a eficiência dos negócios.',
    },
    {
      icon: '../assets/icones/detail.png',
      title: 'Detalhamento e Revisão:',
      description:
        'Ao fim desse ciclo, detalhamos dados e análises e, com a parceria do time técnico, revisamos tudo com foco na melhoria contínua e na superação de expectativas.',
    },
  ]
  const delivery = [
    {
      icon: '../assets/icones/planilha.png',
      title: 'Planejamento Estratégico:',
      description: ' Time recebe um objetivo e discute como vai atingi-lo.',
    },
    {
      icon: '../assets/icones/execucao.png',
      title: 'Execução: ',
      description:
        'Durante o ciclo de duas semanas, denominado Sprint, o time constrói, integra e testa os itens desenvolvidos.',
    },
    {
      icon: '../assets/icones/chart-clock.png',
      title: 'Avaliação de Resultados:',
      description:
        'Ao final do ciclo, o time apresenta os resultados e colhe feedback sobre a evolução do produto.',
    },
    {
      icon: '../assets/icones/implementacao.png',
      title: 'Implementação:',
      description:
        'O resultado de cada ciclo pode ser publicado para os usuários finais.',
    },
  ]

  const handleTabChange = tab => {
    setActiveTab(tab)
  }

  return (
    <section className="bg-[#180E52] pb-2 pt-[138px] px-5 text-white text-center space-y-[117px] relative">
      {/* Tab Navigation */}
      <div className="flex justify-center space-x-10">
        <button
          type="button"
          className={`px-10 py-2 text-3xl transition-all cursor-pointer ${
            activeTab === 'discovery'
              ? 'bg-gradient-to-r from-[#4B3BDB] to-[#A002CB] rounded-full font-inter-bold'
              : 'bg-transparent'
          }`}
          onClick={() => handleTabChange('discovery')}
        >
          Discovery
        </button>
        <button
          type="button"
          className={`px-10 py-2 text-3xl transition-all cursor-pointer ${
            activeTab === 'delivery'
              ? 'bg-gradient-to-r from-[#4B3BDB] to-[#A002CB] rounded-full font-inter-bold'
              : 'bg-transparent'
          }`}
          onClick={() => handleTabChange('delivery')}
        >
          Delivery
        </button>
      </div>

      {/* Tab Content */}
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-24 px-12">
          {(activeTab === 'discovery' ? discovery : delivery).map((item, index) => (
            <div 
              className="flex flex-col items-center" 
              key={index}
            >
              <div className="w-20 h-20 rounded-full relative flex items-center justify-center mb-4">
                <div className="absolute inset-0 rounded-full bg-gradient-to-r from-[#A800E4] via-[#D700E2] via-[#FB00C7] via-[#FF00A0] to-[#FF1B76]" />
                <div className="absolute inset-[1px] rounded-full bg-[#2d1854]" />
                <img src={item.icon} alt="" className="block z-10" />
              </div>

              <h3 className="text-base font-medium mb-3">{item.title}</h3>
              <p className="text-sm leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Pagination Dots */}
      <div className="flex gap-3 items-center justify-center mt-8">
        <button
          onClick={() => handleTabChange('discovery')}
          className={`${
            activeTab === 'discovery'
              ? 'w-[24px]'
              : 'w-[8px]'
          } h-[8px] rounded-full cursor-pointer transition-all duration-300 ${
            activeTab === 'discovery'
              ? 'bg-transparent border border-white'
              : 'bg-white'
          }`}
          aria-label="Show Discovery tab"
        />
        <button
          onClick={() => handleTabChange('delivery')}
          className={`${
            activeTab === 'delivery'
              ? 'w-[24px]'
              : 'w-[8px]'
          } h-[8px] rounded-full cursor-pointer transition-all duration-300 ${
            activeTab === 'delivery'
              ? 'bg-transparent border border-white'
              : 'bg-white'
          }`}
          aria-label="Show Delivery tab"
        />
      </div>

      <img
        src="../assets/grafismo.png"
        alt=""
        className="block absolute top-0 left-0 bg-cover"
      />
      <img
        src="../assets/grafismo-r.png"
        alt=""
        className="block absolute top-0 right-0 bg-cover"
      />
      <img
        src="../assets/shadow.png"
        alt=""
        className="block absolute top-0 left-0 bg-cover w-full"
      />
    </section>
  )
}
